<template>
  <div class="editorCampaignWrapper">
    <div class="editorCampaign">
      <div class="editorCampaign__header">
        <div class="editorCampaign__title">
          <div class="editorCampaign__title__left">
            <h1 class="medium-title">Campaign Channel</h1>
            <span class="subhead">Set Your campaign details</span>
          </div>
          <div class="editorCampaign__title__right">
            <span class="subhead">Channel :</span>
            <div class="custom-label">
              <adx-label-custom
                :color="getColorLabel(channelName)"
                :label="getLabelChannel(channelName)"
              />
            </div>
          </div>
        </div>
        <div class="container-router">
          <div class="title">
            <ul class="title__menu">
              <li
                class="subhead color-grey"
                :class="[isSummary? 'router-link-active': '']"
                @click="selectedTab(1)"
              >Summary</li>
              <li
                class="subhead color-grey"
                :class="[!isSummary? 'router-link-active': '']"
                @click="selectedTab(2)"
              >Placement</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="editorCampaign__body" v-if="!isLoading">
        <div class="editorCampaign__body__left">
          <div
            class="editorCampaign__body__left__airlines-channel"
            v-if="channelName == 'airlines'"
          >
            <adx-airlines-campaign-editor
              :isSummary="isSummary"
              :campaignData="campaignData"
              @updateSummary="updateSummary"
              @addNewLineItem="addNewLineItem"
            ></adx-airlines-campaign-editor>
          </div>
          <div
            class="editorCampaign__body__left__lifestyle-channel"
            v-if="channelName == 'lifestyle'"
          >
            <adx-lifestyle-campaign-editor
              :isSummary="isSummary"
              :campaignData="campaignData"
              @updateSummary="updateSummary"
              @addNewLineItem="addNewLineItem"
            >></adx-lifestyle-campaign-editor>
          </div>
          <div class="editorCampaign__body__left__outdoor-channel" v-if="channelName == 'outdoor'">
            <adx-outdoor-campaign-editor
              :isSummary="isSummary"
              :campaignData="campaignData"
              @updateSummary="updateSummary"
              @addNewLineItem="addNewLineItem"
            ></adx-outdoor-campaign-editor>
          </div>
          <div class="editorCampaign__body__left__airlines-channel" v-if="channelName == 'bus'">
            <adx-bus-campaign-editor
              :isSummary="isSummary"
              :campaignData="campaignData"
              @updateSummary="updateSummary"
              @addNewLineItem="addNewLineItem"
            ></adx-bus-campaign-editor>
          </div>
        </div>
        <div class="editorCampaign__body__right">
          <div class="editorCampaign__body__right__container">
            <h1 class="subhead title">Campaign Summary</h1>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">Selected Item</span>
              <span class="subhead">{{summary.itemCount}}</span>
            </div>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">Start Date</span>
              <span class="subhead">{{summary.campaignStart}}</span>
            </div>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">End Date</span>
              <span class="subhead">{{summary.campaignEnd}}</span>
            </div>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">Period</span>
              <span class="subhead">{{summary.campaignPeriod}} Month</span>
            </div>
          </div>
          <div class="editorCampaign__body__right__container">
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">Subtotal Price</span>
              <span class="subhead color-pink">{{summary.subTotalPrice | formatMoney}}</span>
            </div>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">PPN 10%</span>
              <span class="subhead color-pink">{{ppn | formatMoney}}</span>
            </div>
            <div class="editorCampaign__body__right__container__item">
              <span class="subhead">Total Price</span>
              <span class="price color-pink strong">{{totalPrice | formatMoney}}</span>
            </div>
          </div>
          <div class="editorCampaign__body__right__button__bottom">
            <button
              class="btn-regular primary save"
              @click="validateCampaign(false)"
              :disabled="isLoadingSave"
            >
              Save
              <adx-loading-secondary-white class="sk-circle" v-if="isLoadingSave" />
            </button>
          </div>
        </div>
      </div>
      <adx-loading v-else />
    </div>
    <div class="modal-full">
      <adx-modal v-if="isShowModal" @modal-close="toggleModal" :hideClose="true" type="large">
        <div slot="content" class="editorCampaign__modal">
          <div class="editorCampaign__modal__header">
            <i class="icon-close large-font color-grey" @click="toggleModal"></i>
            <h1 class="title large-font">Add New Items</h1>
          </div>
          <div class="editorCampaign__modal__top">
            <div class="editorCampaign__modal__top__left">
              <div class="search">
                <i class="adx-ic_search"></i>
                <input
                  v-model="searchBoxValue"
                  type="text"
                  placeholder="Search placement or location ..."
                />
              </div>
            </div>
            <div class="editorCampaign__modal__top__right">
              <div class="editorCampaign__modal__top__right__sort">
                <div class="editorCampaign__modal__top__right__sort__label">Sort by:</div>
                <adx-dropdown-sort
                  class="editorCampaign__modal__top__right__sort__dropdown"
                  :value.sync="selectedSortValue"
                  :type="true"
                  :options="sortOptions"
                ></adx-dropdown-sort>
              </div>
            </div>
          </div>
          <div class="editorCampaign__modal__table">
            <table class="table-placement">
              <thead>
                <tr>
                  <th class="btn-header placement-button">
                    <span></span>
                  </th>
                  <th class="item-header mini-font placement-items">ITEMS</th>
                  <th class="mini-font placement-order">MIN ORDER</th>
                  <th class="mini-font placement-price">PRICE</th>
                  <th class="mini-font placement-future">FUTURE PRICE</th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="editorCampaign__modal__table tablebody">
            <table class="table-placement">
              <tbody v-if="!isLoadingPlacement">
                <tr v-for="(item, index) in placementOptions" :key="index">
                  <td class="placement-button" @click.stop="selectItem(item.id, item)">
                    <span class="adx-ic_plus"></span>
                  </td>
                  <td class="placement-items">
                    <div class="item-section" v-if="channelName == 'lifestyle'">
                      <span class="placement-name subhead strong">{{ item.location_data.name }}</span>
                      <span class="location-name subhead">{{ item.name }}</span>
                    </div>
                    <div class="item-section" v-else-if="channelName == 'airlines'">
                      <span class="placement-name subhead strong">{{ item.name }}</span>
                      <span
                        class="location-name subhead"
                      >{{item.location_data.brand}} - {{ item.location_data.name }}</span>
                    </div>
                    <div class="item-section" v-else>
                      <span class="placement-name subhead strong">{{ item.name }}</span>
                      <span class="location-name subhead">{{ item.location_data.name }}</span>
                    </div>
                  </td>
                  <td class="placement-order">
                    <span
                      class="min-period subhead"
                    >{{ minOrder(item.min_period, item.min_period_plan) }}</span>
                  </td>
                  <td class="placement-price">
                    <span class="public-price strong">{{ item.price | formatMoney }}</span>
                  </td>
                  <td class="placement-future">
                    <div v-if="item.future_prices.length > 0" class="futureprice">
                      <span
                        class="futureprice__price subhead"
                      >{{ item.future_prices[0].public_price | formatMoney }}</span>
                      <span
                        class="futureprice__applied mini-font"
                      >{{ getFuturePriceStart(item.future_prices[0].start) }}</span>
                    </div>
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr></tr>
                <tr></tr>
                <tr></tr>
              </tbody>
            </table>
            <div class="editorCampaign__modal__loading" v-if="isLoadingPlacement">
              <adx-loading />
            </div>
            <div
              class="editorCampaign__modal__empty"
              v-if="!isLoadingPlacement && placementOptions.length < 1"
            >
              <adx-empty-selection />
            </div>
          </div>
        </div>
      </adx-modal>
    </div>
  </div>
</template>

<script>
import AirlinesCampaignEditor from "@/views/Campaign/CampaignEditorV2/Airlines";
import LifestyleCampaignEditor from "@/views/Campaign/CampaignEditorV2/Lifestyle";
import OutdoorCampaignEditor from "@/views/Campaign/CampaignEditorV2/Outdoor";
import BusCampaignEditor from "@/views/Campaign/CampaignEditorV2/Bus";
import LoadingSecondaryWhite from "@/components/Loading/Secondary-white";

import Vue from "vue";
import api from "@/api";
import lib from "@/lib/util";
import { apiV2 } from "@/api/urls";
import { helpers } from "@/lib/validation/";
import { mapGetters } from "vuex";
import { restEdge } from "@/api/edgeUrls";
import { globalMixins } from "@/lib/mixins/globalMixins";
import { required, minLength } from "vuelidate/lib/validators";
import {
  ACheckbox,
  AInput,
  ATextArea,
  ASelectDropdown,
  AModal,
  ALoadingSecondary,
  AListDropdown,
  ALoadingSecondaryWhite,
  ASingleSearchDropdown,
  ALoadingPrimary,
  AEmptySelection,
  APagination,
  AStatusLabelCustom
} from "ui-kit-v1";
import moment from "moment";

export default {
  name: "adx-campaign-editor",
  components: {
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondary,
    "adx-loading-white": ALoadingSecondaryWhite,
    "adx-loading-secondary-white": LoadingSecondaryWhite,
    "adx-pagination": APagination,
    "adx-dropdown-sort": ASelectDropdown,
    "adx-dropdown-list": AListDropdown,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-label-custom": AStatusLabelCustom,
    "adx-empty-selection": AEmptySelection,
    "adx-airlines-campaign-editor": AirlinesCampaignEditor,
    "adx-lifestyle-campaign-editor": LifestyleCampaignEditor,
    "adx-outdoor-campaign-editor": OutdoorCampaignEditor,
    "adx-bus-campaign-editor": BusCampaignEditor
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      id: null,
      channelName: null,
      // periodKey: 0,
      quotation: 1,
      isShowModal: false,
      // isShowModalQuotation: false,
      isSummary: true,
      isLoading: false,
      isLoadingForm: false,
      // isLoadingQuotation: false,
      isLoadingSave: false,
      isLoadingPlacement: false,
      popoverVisibility: `focus`,
      startDateFormat: null,
      endDateFormat: null,
      campaignData: null,
      searchBoxValue: null,
      selectedSortValue: "last_added",
      // selectedMediaTypeValue: '',
      token_req: null,
      periodOptions: [],
      placementOptions: [],
      fullPlacementOptions: [],
      // mediaTypeOptions: [],
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added"
        },
        {
          label: "Highest Price",
          value: "price"
        },
        {
          label: "Name",
          value: "name"
        }
      ],
      vuelidateOptions: {
        name: {
          field: "campaign name",
          error: null,
          ref: "name"
        }
      },
      summary: {
        campaignName: null,
        itemCount: null,
        campaignStart: null,
        campaignEnd: null,
        campaignPeriod: 1,
        campaignDuration: 10,
        subTotalPrice: null,
        digitalStartDate: null,
        digitalEndDate: null,
        nonDigitalStartDate: null,
        nonDigitalEndDate: null
      },
      themeStyles: {
        dayContent: {
          fontSize: "15px"
        },
        headerTitle: {
          fontSize: "17px",
          fontWeight: "bold"
        },
        weeks: {
          fontWeight: "bold"
        },
        wrapper: {
          boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
          backgroundColor: "white",
          border: "none"
        },
        header: {
          marginBottom: "6px"
        }
      }
    };
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3) }
    }
  },
  computed: {
    ppn() {
      return this.summary.subTotalPrice
        ? 0.1 * parseInt(this.summary.subTotalPrice)
        : 0;
    },
    totalPrice() {
      return this.summary.subTotalPrice
        ? parseInt(this.summary.subTotalPrice) + this.ppn
        : 0;
    },
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
    filtered: function() {
      let filtered = false;
      if (this.selectedMediaTypeValue) {
        filtered = true;
      }
      return filtered;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.getPlacement();
      });
    }, 500)
  },
  apollo: {},
  beforeCreate() {},
  async created() {},
  async beforeMount() {},
  async mounted() {
    let query = this.$route.query;
    this.id = this.$route.params.id;
    this.getCampaign();
    this.getStartDate();
  },

  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    updateSummary(value) {
      let keys = Object.keys(value);
      // cari tau kenapa jadi infinite loop tanpa + ''
      for (let key of keys) {
        this.summary[key] = value[key] + "";
      }
    },
    getStartDate() {
      this.summary.campaignStart = this.summary.digitalStartDate;
    },
    async getCampaign() {
      this.isLoading = true;
      const { data, status } = await api.get(
        restEdge.getCampaignChannel(this.id),
        { needToken: true, useRestEdge: true }
      );
      if (status == 200) {
        this.channelName = data.channel_name;
		    this.campaignData = data;
        this.quotation = data.quotation;
      }
      this.isLoading = false;
    },
    getColorLabel(channel) {
      if (channel == "airlines") {
        return `#b620e0`;
      } else if (channel == "lifestyle") {
        return `#0091ff`;
      } else if (channel == "outdoor") {
        return `#0fc79e`;
      } else if (channel == "bus") {
        return "#fa6400";
      }
    },
    getLabelChannel(channel) {
      if (channel == "airlines") {
        return `AIRLINES`;
      } else if (channel == "lifestyle") {
        return `LIFESTYLE`;
      } else if (channel == "outdoor") {
        return `OUTDOORS`;
      } else if (channel == "bus") {
        return "BUS ADVERTISING";
      }
    },
    addNewLineItem(value) {
      this.isShowModal = value.isShowModal;
      this.getPlacement();
    },
    toggleModal() {
      this.isShowModal = !this.isShowModal;
    },
    resetFilter() {
      this.selectedMediaTypeValue = null;
      this.getPlacement();
    },
    saveToLocal(data = null) {
      let localData = {
        model: {
          selectedCampaign: [this.id],
          totalCampaignPrice: this.model.subTotalPrice,
          startDate: this.campaignStart,
          endDate: this.campaignEnd
        },
        dates: {
          listStartDate: [this.startDateFormat],
          listEndDate: [this.endDateFormat]
        }
      };
      localStorage.setItem("selectedCampaignDraft", JSON.stringify(localData));
    },
    addMoreCampaign() {
      this.saveToLocal();
      this.saveToDraft(false);
    },
    async loadFilter() {
      const params = { channel: this.channelName };
      const { data, status } = await api.get(
        restEdge.billboardPricelistFilter,
        { params: params, needToken: true, useRestEdge: true }
      );
      if (status === 200) {
        this.mediaTypeOptions = data.media_type.map(type => ({
          id: type.id,
          label: type.name,
          value: type.id
        }));
      } else {
        this.showNotificationAlert(
          "Error",
          "Ops, something went wrong.",
          "danger"
        );
      }
    },
    selectItem(id, placementItem) {
      this.isItemExist(id, placementItem);
      let item = this.getObject(id).pop();
      let indexItem = this.placementOptions.indexOf(item);
      this.placementOptions.splice(indexItem, 1);
    },
    minOrder(minPeriod, minPeriodPlan) {
      return `${minPeriod} ${minPeriodPlan}`;
    },
    getFuturePriceStart(date) {
      let start = moment(date, "YYYY-MM-DD");
      return `Applied ${start.format("DD MMM YYYY")}`;
    },
    isItemExist(id, placementItem) {
      let item = this.getObjectAvail(id).pop();
      //push item to line item list
      if (this.channelName == "airlines") {
        this.campaignData.campaign_medias[0].line_item_list.push({
          price: placementItem.price,
          line_item: placementItem,
          item_price: placementItem.price,
          slot: placementItem.quantity
        });
      } else if (this.channelName == "outdoor") {
        let index = 0;
        if (this.campaignData.campaign_medias[0].media_type == "digital") {
          if (placementItem.media_type == "Non Digital") {
            this.campaignData.campaign_medias.push({
              media_type: "nondigital",
              start: new Date(),
              end: new Date(),
              line_item_list: []
            });
            index = 1;
          }
        } else {
          if (placementItem.media_type == "Digital") {
            this.campaignData.campaign_medias.push({
              media_type: "digital",
              start: new Date(),
              end: new Date(),
              line_item_list: []
            });
            index = 1;
          }
        }

        this.campaignData.campaign_medias[index].line_item_list.push({
          price: placementItem.price,
          line_item: placementItem,
          item_price: placementItem.price
          // slot: placementItem.quantity
        });
      } else if (this.channelName == "lifestyle") {
        this.campaignData.campaign_medias[0].line_item_list.push({
          price: placementItem.price,
          line_item: placementItem,
          item_price: placementItem.price
        });
      } else if (this.channelName == "bus") {
        this.campaignData.campaign_medias[0].line_item_list.push({
          price: placementItem.price,
          line_item: placementItem,
          item_price: placementItem.price
        });
      }
      this.showNotificationAlert(
        "Success",
        "Placement succesfully added to campaign",
        "success"
      );
      this.getTotalItemAndPrice(this.campaignData.campaign_medias);
    },
    getTotalItemAndPrice(campaignMedias) {
      let totalItem = 0;
      let totalPrice = 0;
      for (let media of campaignMedias) {
        totalItem += media.line_item_list.length;
        for (let item of media.line_item_list) {
          if (this.channelName == "outdoor") {
            totalPrice += item.price * item.line_item.min_period * this.summary.campaignDuration;
          } else if (this.channelName == "airlines") {
            totalPrice += (item.line_item.calculated_public_price ? 
              item.line_item.calculated_public_price : item.price) * media.cycle;
          } else {
            totalPrice += item.price * media.period;
          }
        }
      }

      this.summary.itemCount = totalItem;
      this.summary.subTotalPrice = totalPrice;
    },
    getObjectAvail(id) {
      return this.fullPlacementOptions.filter(x => {
        return x.id == id;
      });
    },
    getObject(id) {
      return this.placementOptions.filter(x => {
        return x.id == id;
      });
    },
    async getPlacement() {
      this.isLoadingPlacement = true;
      let response = null;
      let params = {
        search: this.searchBoxValue,
        sort: this.selectedSortValue
      };

      let random_numb = Math.random()
      this.token_req = random_numb;

      if (this.channelName == "outdoor") {
        response = await api.get(restEdge.outdoorLineItem, {
          params: params,
          needToken: true,
          useRestEdge: true
        });
      } else if (this.channelName == "lifestyle") {
        response = await api.get(restEdge.lifestyleLineItem, {
          params: params,
          needToken: true,
          useRestEdge: true
        });
      } else if (this.channelName == "airlines") {
        response = await api.get(restEdge.airlinesLineItem, {
          params: params,
          needToken: true,
          useRestEdge: true
        });
      }
      else {
        response = await api.get(restEdge.airlinesLineItem, {
          params: params,
          needToken: true,
          useRestEdge: true
        });
      } 

      if (response.status == 200) {
        if (random_numb == this.token_req) {
          let outdoorBody = null;
          this.fullPlacementOptions = response.data.map(placement => {
            return {
              id: placement.id,
              label:
                (placement.location_data ? placement.location_data.name : "") +
                " - " +
                placement.name,
              value: placement.id,
              name: placement.name,
			        price: 
			 	        this.channelName === "airlines" ? placement.calculated_public_price : placement.public_price,
              bottom_price: placement.bottom_price,
              placement: placement.name,
              location_data:
                this.channelName == "lifestyle" || this.channelName == "outdoor"
                  ? placement.location
                  : placement.location_data,
              period: placement.min_period,
              lead_pre_time: placement.lead_time,
              future_prices: placement.future_prices,
              min_period: placement.min_period,
              min_period_plan: placement.pricing_unit,
              quantity: placement.quantity,
              media_type:
                this.channelName == "outdoor" ? placement.media_type : null
            };
          });

          //get existing placement id
          let existingPlacementIds = [];
          this.campaignData.campaign_medias.map(x => {
            x.line_item_list.map(y => {
              existingPlacementIds.push(y.line_item.id);
            });
          });

          // get placement
          let placements = [];
          this.placementOptions = this.fullPlacementOptions.map(placement => {
            if (!existingPlacementIds.includes(placement.id)) {
              placements.push(placement);
            }
          });
		  this.placementOptions = placements;
        }
      }
      this.isLoadingPlacement = false;
    },
    selectedTab(item) {
      this.isSummary = item == 1;
    },
    displayDate(date) {
      return `${lib.dateFormat("YYYY-MM-DD", "DD MMM YYYY", new Date(date))}`;
    },
    validateCampaign(isCreateQuotation) {
      // this.$v.$touch()
      // if (this.$v.model.$invalid) {
      //   this.vuelidateHelper(this.vuelidateOptions)
      // } else {
      this.saveToDraft(false);
      // }
    },
    async saveToDraft(isQuotation = false) {
      let list_item_id = [];
      let digital_list_item = [];
      let non_digital_list_item = [];
      let campaign_medias = [];

      this.isLoadingSave = true;
      this.campaignData.campaign_medias.map(media => {
        media.line_item_list.map(item => {
          if (this.channelName == "outdoor") {
            media.media_type.toLowerCase() == "digital"
              ? digital_list_item.push(item.line_item.id)
              : non_digital_list_item.push(item.line_item.id);
          } else if (this.channelName == "airlines" || "bus") {
            list_item_id.push({ id: item.line_item.id, slot: item.slot });
          } else {
            list_item_id.push(item.line_item.id);
          }
        });
      });
      //define campaign medias baase on channel
      if (this.channelName == "outdoor") {
        // campaign_medias = [
        //   {
        //     list_item: non_digital_list_item,
        //     duration: 1,
        //     start: new Date(this.summary.nonDigitalStartDate),
        //     end: new Date(this.summary.nonDigitalEndDate),
        //     media_type: "nondigital"
        //   },
        //   {
        //     list_item: digital_list_item,
        //     duration: this.summary.campaignDuration,
        //     start: new Date(this.summary.digitalStartDate),
        //     end: new Date(this.summary.digitalEndDate),
        //     media_type: "digital"
        //   }
        // ]

        campaign_medias = [];
        if (non_digital_list_item.length > 0) {
          campaign_medias.push({
            list_item: non_digital_list_item,
            duration: 1,
            start: new Date(this.summary.nonDigitalStartDate),
            end: new Date(this.summary.nonDigitalEndDate),
            media_type: "nondigital"
          });
        }

        if (digital_list_item.length > 0) {
          campaign_medias.push({
            list_item: digital_list_item,
            duration: this.summary.campaignDuration,
            start: new Date(this.summary.digitalStartDate),
            end: new Date(this.summary.digitalEndDate),
            media_type: "digital"
          });
        }
      } else if (this.channelName == "airlines") {
        campaign_medias = [
          {
            list_item: list_item_id,
            cycle: this.summary.campaignPeriod,
            start: new Date(this.summary.campaignStart),
            end: new Date(this.summary.campaignEnd)
          }
        ];
      } else if (this.channelName == "lifestyle") {
        campaign_medias = [
          {
            list_item: list_item_id,
            period: this.summary.campaignPeriod,
            start: new Date(this.summary.campaignStart),
            end: new Date(this.summary.campaignEnd)
          }
        ];
      } else if (this.channelName == "bus") {
        campaign_medias = [
          {
            list_item: list_item_id,
            period: this.summary.campaignPeriod,
            start: new Date(this.summary.campaignStart),
            end: new Date(this.summary.campaignEnd)
          }
        ];
      }

      let body = {
        name: this.summary.campaignName,
        campaign_medias: campaign_medias,
        owner: this.campaignData.owner,
        quotation: this.quotation ? this.quotation : null,
        channel_name: this.channelName,
        service_fee: 0
      };

      const { data, status } = await api.put(
        restEdge.editCampaignChannel(this.id),
        body,
        {
          needToken: true,
          useRestEdge: true
        }
      );
      if (status == 200) {
        if (!isQuotation)
          this.showNotificationAlert(
            "Success",
            "campaign Successfully changed!",
            "success"
          );
        if (this.quotation) {
          this.$router.push({
            name: "quotationedit",
            params: { id: this.quotation }
          });
        } else {
          this.$router.push({ name: "draftcampaign" });
        }
      } else {
        this.showNotificationAlert(
          "Error",
          "Campaign failed to save!",
          "danger"
        );
      }
      if (!isQuotation) this.isLoadingSave = false;
    },
    vuelidateHelper(vuelidateOptions) {
      const {
        key,
        message,
        element,
        collection
      } = helpers.vuelidateValidationHelper(
        this.$v.model,
        vuelidateOptions,
        this.$refs
      );

      if (collection) {
        vuelidateOptions[key].error[collection.index][
          collection.collectionKey
        ] = message;
      } else {
        vuelidateOptions[key].error = message;
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
<style lang='scss'>
.editorCampaignWrapper {
  .modal {
    .modal__content {
      height: 80%;
    }
  }
  .modal-quotation {
    .modal {
      .modal__content {
        height: max-content;
      }
    }
  }
  .modal-full {
    .modal {
      margin-top: 7%;
      .modal__content {
        height: max-content;
        &__header {
          margin-bottom: unset;
        }
        .editorCampaign__modal__top__left {
          .search,
          .mediatype {
            height: 38px;
          }
        }
        .editorCampaign__modal__top__right {
          &__sort {
            height: 38px;
          }
        }
      }
    }
  }
  .frontIcon {
    width: 1px;
  }
  .editorCampaign {
    // .selectDropdown .select input {
    //   min-height: 63px !important;
    // }
    .input input {
      min-height: 63px !important;
    }
    .periodWrapper {
      .selectDropdown {
        .popup {
          overflow: auto;
          height: 200px;
        }
      }
    }
  }
}
</style>
